<script lang="ts">
  import DateTimeContent from "$lib/content/components/DateTimeContent.svelte";
  import type { LayoutProps } from "$lib/layouts/layoutTypes";
  import { t } from "$lib/utils/i18n";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";

  import elev8LogoPngUrl from "$assets/elev8-by-vertical-city-logo-full-colour-highres.png";

  const {
    logoUrl = elev8LogoPngUrl,
    ContentMain,
    ContentSecondary,
    ContentTertiary,
    ContentWeather,
  }: LayoutProps = $props();
  const config = getConfigurationContext();
</script>

<div class="layout-wrapper" data-layout="kone">
  <div class="top-bar">
    <div class="top-bar__logo-container">
      <img
        src={logoUrl}
        alt={t("alt.propertyLogo", config.language)}
        class="top-bar__logo-img"
        crossorigin="anonymous"
      />
    </div>
    <svg
      class="top-bar__logo-separator"
      viewBox="0 0 1 5"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <polygon class="top-bar__logo-separator-polygon" points="0,0 1,2.5 0,5" />
    </svg>
    <div class="date-time">
      <DateTimeContent />
    </div>
  </div>
  <div class="content-main vc-aspect-ratio ratio-is-16x9">
    <div class="vc-aspect-ratio__content">
      {@render ContentMain?.()}
    </div>
  </div>
  <div class="bottom-bar justify-content-stretch-fix">
    <!-- {@render ContentSecondary?.()}
    {@render ContentTertiary?.()} -->
    {@render ContentWeather?.()}
  </div>
</div>

<style>
  .layout-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--vc-white);
    color: var(--vc-black);
    --kone-font-size-multiplier: 1;
  }

  .top-bar {
    flex: 3;
    display: flex;
    flex-direction: row;
    background: var(--vc-black);
    color: var(--vc-white);
    /* border-bottom: 1px solid var(--vc-neutral-light); */
  }

  .top-bar__logo-container {
    flex: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--vc-white);
  }

  .top-bar__logo-separator-polygon {
    fill: var(--vc-white);
  }

  .top-bar__logo-separator {
    /*
      Oversize height + negative margin to hide a mysterious thin line
      caused by Chrome rendering issue
      https://stackoverflow.com/a/59869309
    */
    --over-fit: 6px;
    height: calc(100% + var(--over-fit));
    margin: calc(var(--over-fit) / -2) 0 auto -1px;
    width: auto;
    display: block;
    flex: none;
  }

  .top-bar__logo-img {
    display: inline-block;
    max-height: 95%;
    max-width: 95%;
    object-fit: contain;
    vertical-align: middle;
    overflow: auto;
  }

  .date-time {
    flex: 5;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: calc(1rem * var(--kone-font-size-multiplier));
    /* padding: 5em 0; */
  }

  .date-time :global(.time) {
    font-size: 6.6em;
    font-weight: 600;
    line-height: 1;
    color: var(--vc-white);
  }

  .date-time :global(.date) {
    font-size: 2.7em;
    font-weight: 400;
    border-bottom: thin var(--vc-white) solid;
    opacity: 0.8;
    color: var(--vc-white);
  }

  .content-main {
    background-color: var(--vc-white);
    overflow: hidden;
  }

  .bottom-bar {
    flex: 3;
    background: var(--vc-white);
    display: flex;
    align-items: stretch;
    color: var(--vc-black);

    /* Layout-specific component token overrides */
    --weather-border-top: 1px solid var(--vc-neutral-dark-10);
    --weather-day-border: none;
    --weather-day-bg-alt: var(--vc-black);
    --weather-day-text-alt: var(--vc-white);
    --weather-day-padding: 0 2em;
    --weather-content-font-size: calc(
      1.4rem * var(--kone-font-size-multiplier)
    );
    --notice-border-color: transparent;
  }

  @media (orientation: portrait) {
    .layout-wrapper {
      --kone-font-size-multiplier: 1.5;
    }
    .top-bar {
      flex: 4;
    }
    .bottom-bar {
      --weather-day-padding: 0.5em 0.5em 1em 1em;
      --weather-day-conditions-margin: 1.5em 0 0;
    }
  }

  @media (orientation: landscape) {
    .layout-wrapper {
      --kone-font-size-multiplier: 1;
    }
  }
</style>
